import { useEffect, useState } from 'react'

import shortlistApi from '@modules/shortlist/api'
import { useMutation, useQuery } from '@tanstack/react-query'

import { ShotlistDownload, ShotlistDownloadStatus } from '../types'

export const useShortlistDownload = ({ activeShortlistId }: { activeShortlistId?: number }) => {
  const [fetchDownloadStatus, setFetchDownloadStatus] = useState<boolean>(false)
  const { mutate: downloadShortlist } = useMutation({
    mutationFn: shortlistApi.downloadShortlist.fn,
    onSuccess: () => {
      setFetchDownloadStatus(true)
    },
  })

  const { refetch: refetchShortlistDownload, data: shortlistDownloadData } = useQuery({
    queryKey: [shortlistApi.getDownloadShortlistStatus.key, activeShortlistId],
    queryFn: () => shortlistApi.getDownloadShortlistStatus.fn({ id: activeShortlistId }),

    enabled: fetchDownloadStatus && !!activeShortlistId,
    refetchInterval: fetchDownloadStatus ? 2000 : false,
    refetchIntervalInBackground: true,
  })

  useEffect(() => {
    if (shortlistDownloadData) {
      const { download } = shortlistDownloadData as {
        download: ShotlistDownload
      }
      if (download) {
        if (download.status === ShotlistDownloadStatus.SUCCESS) {
          setFetchDownloadStatus(false)
          const link = document.createElement('a')
          link.href = download.url
          link.click()
        }
        if (download.status === ShotlistDownloadStatus.IN_PROGRESS && !fetchDownloadStatus) {
          setFetchDownloadStatus(true)
        }
      }
    }
  }, [shortlistDownloadData, fetchDownloadStatus])

  useEffect(() => {
    if (activeShortlistId) {
      refetchShortlistDownload()
    }
  }, [activeShortlistId, refetchShortlistDownload])
  return { downloadShortlist, fetchDownloadStatus }
}
